import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import "./style.scss";

const DateInput = ({
  label,
  required = true,
  icon,
  inputValue,
  setInputValue,
  errorMsg,
  type = "date", // Default 'date' bana diya
  minDate, // Optional - override today
}) => {
  const [todayDate, setTodayDate] = useState("");

  // 🔥 TODAY DATE CALCULATE KARO (YYYY-MM-DD format)
  useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Time zero kar do
    const formattedDate = today.toISOString().split('T')[0]; // YYYY-MM-DD
    setTodayDate(formattedDate);
  }, []);

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  // 🔥 MIN DATE - Today ya passed minDate
  const getMinDate = () => {
    return minDate || todayDate; // minDate pass kiya to wo, nahi to today
  };

  return (
    <div className="date-container">
      {label && (
        <div className="lable-container">
          <span>{label}</span>
          {required && <span className="star">*</span>}
        </div>
      )}

      <div className="text-field-container">
        <input
          className={`text-field ${errorMsg ? "error-msg" : ""} ${!inputValue ? "empty" : ""}`}
          type={type}
          value={inputValue}
          onChange={handleChange}
          min={getMinDate()} // 🔥 TODAY se future only!
          // Arrival date ke liye departure se pehle ho to validation alag se
        />

        {icon && (
          <SVG
            className="input-icon"
            fill={!inputValue ? "gray" : ""}
            src={icon}
          />
        )}
      </div>

      {errorMsg && <span className="error-msg-container">{errorMsg}</span>}
    </div>
  );
};

export default DateInput;
